import { createSelector } from '@reduxjs/toolkit';
import { get, isString, isNil } from 'lodash/fp';
import type { RootState } from 'app/store/reducers';
import { selectCurrentViewId } from 'app/store/view/selectors.js';
import type { PreferencesSlice } from './reducer';
import { DEFAULT_TAB, ProjectTabId } from './constants';

const selectSlice = (state: RootState) => state.preferences;

const selectPropEntityId = (_: RootState, props: { entityId: string }) => props.entityId;

export const selectIsPreviewMaximized = createSelector(selectSlice, get('isPreviewMaximized'));
export const selectIsAutorunPreview = createSelector(selectSlice, get('isAutorunPreview'));
const selectWorkbenchDatasetTab = createSelector(selectSlice, get('workbenchDatasetTab'));

const resolveWorkbenchDatasetTab = (
    workbenchDatasetTab: null | string | PreferencesSlice['workbenchDatasetTab'],
    entityId: string
) => {
    // cheap migration if localstorage has old version
    if (isNil(workbenchDatasetTab)) {
        return DEFAULT_TAB;
    }

    if (isString(workbenchDatasetTab)) {
        return workbenchDatasetTab;
    }

    return workbenchDatasetTab.byEntityId[entityId] ?? workbenchDatasetTab.default;
};

export const selectWorkbenchDatasetTabForEntityId = createSelector(
    [selectWorkbenchDatasetTab, selectPropEntityId],
    (workbenchDatasetTab, entityId) => resolveWorkbenchDatasetTab(workbenchDatasetTab, entityId)
);

export const selectSelectedWorkbenchDatasetTab = createSelector(
    [selectWorkbenchDatasetTab, selectCurrentViewId],
    // @ts-expect-error [TODO] type view store slice
    (workbenchDatasetTab, entityId) => resolveWorkbenchDatasetTab(workbenchDatasetTab, entityId)
);

export const selectWorkbenchProjectTab = createSelector(selectSlice, (preferences) => {
    const tabId = preferences.workbenchProjectTab;

    if (Object.values(ProjectTabId).includes(tabId)) {
        return tabId;
    }

    return ProjectTabId.OUTPUT_TABLES;
});

export const selectWorkbenchGroupTab = createSelector(selectSlice, get('workbenchGroupTab'));

export const selectWorkbenchInspectorTab = createSelector(
    selectSlice,
    get('workbenchInspectorTab')
);

export const selectProjectInspectorTab = createSelector(selectSlice, get('projectInspectorTab'));
